import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CountriesService {
    private readonly france = {
        value: 'france',
        label: 'France',
        phoneCode: 'fr',
        countryCode: 'FR',
    };
    private readonly belgium = {
        value: 'belgique',
        label: 'Belgique',
        phoneCode: 'be',
        countryCode: 'BE',
    };
    private readonly luxembourg = {
        value: 'luxembourg',
        label: 'Luxembourg',
        phoneCode: 'lu',
        countryCode: 'LU',
    };

    private readonly countries = [this.france, this.belgium, this.luxembourg];

    get allCountries() {
        return this.countries;
    }

    get defaultCountry() {
        return this.france;
    }

    getPhoneCountry(country) {
        return this.allCountries.find(x => x.value === country)?.phoneCode ?? this.france.phoneCode;
    }

    getCountryCode(country?: string) {
        const normalizedCountry = country?.toLowerCase();
        const countryCode = this.allCountries.find(({ value, countryCode }) => value === normalizedCountry || countryCode.toLowerCase() === normalizedCountry)?.countryCode;

        return countryCode ?? '';
    }
}
